module.exports = __webpack_public_path__ + "img/73.036f7119.jpg";